import ar from "./ar.json";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import et from "./et.json";
import fr from "./fr.json";
import id from "./id.json";
import ja from "./ja.json";
import ko from "./ko.json";
import pt from "./pt.json";
import ru from "./ru.json";
import th from "./th.json";
import tr from "./tr.json";
import vi from "./vi.json";
import zh from "./zh.json";

// One file per CMS locale, written by `pnpm translations`.
const translations: Record<string, Record<string, string>> = {
  en,
  ar,
  de,
  es,
  et,
  fr,
  id,
  ja,
  ko,
  pt,
  ru,
  th,
  tr,
  vi,
  zh,
};

export default translations;
